<template>
  <b-row>
    <b-col md="6" class="mb-2">
      <b-form-group>
        <label :for="'i-current-value-' + request.id">
          {{ $t("Current value") }}
        </label>
        <b-form-checkbox
          :id="'i-current-value-' + request.id"
          name="check-button"
          v-model="oldValue"
          switch
          disabled
        >
          {{ oldValueTestimonialsVisibilityText }}
        </b-form-checkbox>
      </b-form-group>
    </b-col>
    <b-col md="6" class="mb-2">
      <b-form-group>
        <label :for="'i-new-value-' + request.id">
          {{ $t("New value") }}
        </label>
        <b-form-checkbox
          :id="'i-new-value-' + request.id"
          name="check-button"
          v-model="newValue"
          switch
        >
          {{ newValueTestimonialsVisibilityText }}
        </b-form-checkbox>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BButton,
  BCard,
  BCardText,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BRow,
} from "bootstrap-vue";

export default {
  components: {
    BButton,
    BCard,
    BCardText,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BRow
  },
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newValue: null,
      oldValue: null
    };
  },
  computed: {
    oldValueTestimonialsVisibilityText() {
      return this.oldValue ? this.$t('Yes') : this.$t('No')
    },
    newValueTestimonialsVisibilityText() {
      return this.newValue ? this.$t('Yes') : this.$t('No')
    }
  },
  created() {
    this.oldValue = parseInt(this.request.old_value) ? true : false
    this.newValue = parseInt(this.request.new_value) ? true : false
  },
  methods: {
    isValid() {
      return true;
    },
    collectData() {
      return {
        new_value: this.newValue
      }
    }
  }
};
</script>